import { Form as FormGuard } from 'form-guard';
import Validator             from "./Validator";

export default class Form extends FormGuard {
    getValidator() {
        return new Validator(this, this.rules());
    }
}
